<template>
  <div>
    <div v-if="mypagemodal" class="mypagemodal">
      <div class="modal-wrapper">
        <div class="mypagemodal-container">
          <div class="mypagemodal-header">
            <button class="close" @click="mypagetoggleModal">
              <img width="15px" src="../assets/img/mymenu_x.png" />
            </button>
            <h1 class="mypage-title">마이페이지</h1>
          </div>
          <div class="mypage-presscard">
            <div class="user">
              <h1 class="user-header">DOKDO</h1>
              <div
                v-if="user_image != ''"
                class="user-default-img"
                v-bind:style="{ 'background-image': 'url(' + user_image + ')' }"
              ></div>
              <div v-else class="user-default-img"></div>
              <h2 class="user-name">{{ user_name }}</h2>
              <p>칙령 제41호</p>
              <p v-if="levelid == 1">독도 알림이</p>
              <p v-else-if="levelid == 2">독도 돌봄이</p>
              <p v-else-if="levelid == 3">독도 지킴이</p>
              <p v-else-if="levelid == 4">독도 지킴이</p>
              <p v-else>독도 배움이</p>
            </div>
          </div>
          <div class="mypage-box">
            <h2>기자 점수</h2>
            <div class="mypage-box-content">
              <div class="article-point-star"></div>
              <p>{{ pointprops }}P</p>
            </div>
          </div>
          <div v-if="isfinal">
            <img class="mypage-print" src="../assets/img/mypage-print.png" />
            <router-link
              v-if="articles_foredit.length"
              class="printer"
              to="/print"
              @click.native.prevent="loadforEditArticle"
              >결과 출력소</router-link
            >
          </div>
          <div class="mypage-box">
            <h2>내 레벨</h2>
            <div class="mypage-box-content">
              <img
                v-if="totalpoint < 2000"
                :src="require(`../assets/img/grade_img_0.png`)"
              />
              <img
                v-else
                :src="require(`../assets/img/grade_img_${levelid}.png`)"
              />
            </div>
          </div>
          <div class="mypage-box mypage-badge-box">
            <h2>내 뱃지</h2>
            <div class="mypage-box-content">
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[0] == 8"
                    src="../assets/img/마이페이지-인물.png"
                  />
                  <img v-else src="../assets/img/마이페이지-인물-off.png" />
                  <p>인물</p>
                </div>
              </div>
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[1] == 8"
                    src="../assets/img/마이페이지-지리영토.png"
                  />
                  <img v-else src="../assets/img/마이페이지-지리영토-off.png" />
                  <p>지리/영토</p>
                </div>
              </div>
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[2] == 7"
                    src="../assets/img/마이페이지-침탈.png"
                  />
                  <img v-else src="../assets/img/마이페이지-침탈-off.png" />
                  <p>침탈</p>
                </div>
              </div>
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[3] == 8"
                    src="../assets/img/마이페이지-역사.png"
                  />
                  <img v-else src="../assets/img/마이페이지-역사-off.png" />
                  <p>역사</p>
                </div>
              </div>
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[4] == 9"
                    src="../assets/img/마이페이지-생태자원.png"
                  />
                  <img v-else src="../assets/img/마이페이지-생태자원-off.png" />
                  <p>생태/자원</p>
                </div>
              </div>
              <div class="mypage-badge">
                <div class="mypage-badge-content">
                  <img
                    v-if="sectionStates[5] == 6"
                    src="../assets/img/마이페이지-문화예술.png"
                  />
                  <img v-else src="../assets/img/마이페이지-문화예술-off.png" />
                  <p>문화예술</p>
                </div>
              </div>
            </div>
          </div>
          <div class="gofinaldiv" v-if="isfinal"></div>
          <div class="gofinaldiv2" v-if="!isfinal">
            <router-link
              class="gofinal"
              to="/final"
              @click.native.prevent="loadforEditArticle"
              >취재 종료</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <button class="mypage" @click="mypagetoggleModal">마이페이지</button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
/* eslint-disable */
export default {
  props: ["levelid", "pointprops", "isfinal"],
  data() {
    return {
      mypagemodal: false,
      username: "default",
    };
  },
  methods: {
    mypagetoggleModal() {
      this.mypagemodal = !this.mypagemodal;
      this.$store.dispatch("loadSectionState");
    },
    loadforEditArticle() {
      this.$store.dispatch("loadforEditArticle");
    },
  },
  computed: {
    ...mapState(["user_name", "user_image", "totalpoint"]),
    ...mapGetters(["sectionStates", "articles_foredit"]),
  },
};
</script>

<style>
@font-face {
  font-family: "american_typewriter";
  src: url("../assets/fonts/american_typewriter.ttf") format("truetype");
}
</style>




// WEBPACK FOOTER //
// src/components/mypage.vue